module.exports = __webpack_public_path__ + "static/ContactBack-min-fc378449e214d6dd88f7586ea6f24e69.jpg";